import { createContext } from 'react'
import { TNavItemVariant } from './NavItem'

export interface INavContext {
  /**
   * Can be 'filled' or 'transparent'.
   */
  variant: TNavItemVariant
  /**
   * Whether the navigation item is collapsed.
   */
  isCollapsed: boolean
}

/**
 * @internal Do not use this context directly.
 */
export const NavContext = createContext<INavContext>({
  variant: 'filled',
  isCollapsed: false,
})
